// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/fitness-to-fly-grounding.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/fitness-to-fly-grounding/fitness-to-fly-grounding.js';

mount([g0]);
